/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { PublicKeyCredentialParams } from './PublicKeyCredentialParams';
import {
    PublicKeyCredentialParamsFromJSON,
    PublicKeyCredentialParamsFromJSONTyped,
    PublicKeyCredentialParamsToJSON,
} from './PublicKeyCredentialParams';

/**
 * 
 * @export
 * @interface PublicKeyCredential
 */
export interface PublicKeyCredential {
    /**
     * 
     * @type {CredentialType}
     * @memberof PublicKeyCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PublicKeyCredentialParams}
     * @memberof PublicKeyCredential
     */
    params: PublicKeyCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof PublicKeyCredential
     */
    label?: string;
}

/**
 * Check if a given object implements the PublicKeyCredential interface.
 */
export function instanceOfPublicKeyCredential(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function PublicKeyCredentialFromJSON(json: any): PublicKeyCredential {
    return PublicKeyCredentialFromJSONTyped(json, false);
}

export function PublicKeyCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicKeyCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': CredentialTypeFromJSON(json['type']),
        'params': PublicKeyCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function PublicKeyCredentialToJSON(value?: PublicKeyCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': CredentialTypeToJSON(value.type),
        'params': PublicKeyCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

